import { ValueGetterParams } from "ag-grid-community";
import numeral from "numeral";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";
import { money } from "@/utils/numeral/money";
import { ForecastOption } from "@/services/cloudchipr.api";

export const billingExplorerWidgetLabelValueGetter = ({
  data,
}: ValueGetterParams<ResourceExplorerGridDataWithId>) =>
  data?.label ?? data?.field ?? "-";

export const billingExplorerWidgetTotalCostValueGetter = ({
  data,
}: ValueGetterParams<ResourceExplorerGridDataWithId>) => {
  if (!data) {
    return "N/A";
  }

  return isNaN(data?.total_cost) ? "N/A" : money(data?.total_cost);
};

export const billingExplorerWidgetPrevCostValueGetter = ({
  data,
}: ValueGetterParams<ResourceExplorerGridDataWithId>) => {
  return money(data?.previous_period_total_cost);
};

export const billingExplorerWidgetTrendValueGetter = ({
  data,
}: ValueGetterParams<ResourceExplorerGridDataWithId>) => {
  if (!data?.trend && data?.trend !== 0) {
    return "N/A";
  }
  const plusSign = data.trend > 0 ? "+" : "";

  return `${plusSign}${numeral(data.trend).format("0.00")}%`;
};

export const getBillingExplorerWidgetForecastedCostValueGetter =
  (forecastOption?: ForecastOption) =>
  ({ data }: ValueGetterParams<ResourceExplorerGridDataWithId>) => {
    const cost = money(
      (forecastOption === "month"
        ? data?.monthly_forecast?.cost
        : data?.quarterly_forecast?.cost) ?? "",
    );

    return cost !== "N/A" ? `~${cost}` : "N/A";
  };
